import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ValidationMessageComponent } from "./validation-message/validation-message.component";
import { HeaderComponent } from "./layout/header/header.component";
import { SideBarComponent } from "./layout/side-bar/side-bar.component";
import { BreadcrumbComponent } from "./layout/breadcrumb/breadcrumb.component";
import { RouterModule } from "@angular/router";
import { TransactionStatusPipe } from "../../pipes/transaction-status.pipe";
import { NgxShimmerLoadingModule } from "ngx-shimmer-loading";
import { CommonNumberDirective } from "../../pipes/common-number.directive";
import { BsDatepickerModule, DatepickerModule } from "ngx-bootstrap/datepicker";
import { ImageCropperComponent } from "./layout/image-cropper/image-cropper.component";
import { ImageCropperModule } from "ngx-image-cropper";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { RepeatTimesPipe } from "../../pipes/repeat-times.pipe";
import { AbsPipe } from "../../pipes/abs.pipe";
import { NgxUiLoaderModule } from "ngx-ui-loader";
import { ConfirmBoxComponent } from "./components/confirm-box/confirm-box.component";
import { TranslateModule } from "@ngx-translate/core";
import { CardImageDirective } from "./directives/card-image.directive";
import { CommaSeparatDirective } from "./directives/comma-separat.directive";
import { CardNumberDirective } from "./directives/card-number.directive";
import { DateFormatPipe } from "src/app/pipes/format-date.pipe";
import { SpaceRemovalPipe } from "src/app/pipes/space-removal.pipe";
import { PaginationComponent } from "./components/pagination/pagination.component";
import { PaginationModule } from "ngx-bootstrap/pagination";
import { CurrencyAmountComponent } from "./components/currency-amount/currency-amount.component";
import { TwoSideRowComponent } from "./components/transaction/row/component";
import { InfoBoxComponent } from "./components/info-box/component";
import { ButtonComponent } from "./components/button/component";
import { TabComponent } from "./layout/tab/component";
import { TabsModule } from "ngx-bootstrap/tabs";
import { PureInputComponent } from "./components/input/component";
import { FormControlInputComponent } from "./components/form-input/component";
import { ToggleSwitchComponent } from "./components/form-toggle/component";
import { ImageUploadComponent } from "./components/image-input/component";
import { SelectableChipControlComponent } from "./components/selectable-chip/component";
import { RadioButtonGroupComponent } from "./components/select-radio-btn/component";
import { PageBoxWithBackComponent } from "./layout/page-box-with-back/component";
import { GeneralTableComponent } from "./components/table/component";
import { TypeaheadInputComponent } from "./components/typeahead/component";
import { TypeaheadModule } from "ngx-bootstrap/typeahead";
import { MultiSelectCheckboxComponent } from "./components/checkbox-multiselect/component";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown";
import { MultiSelectDropdownComponent } from "./components/multi-select/component";
import { PopoverModule } from "ngx-bootstrap/popover";
import { BaseInfiniteScrollComponent } from "./components/infinite-scroll-container/component";
import { InfiniteScrollModule } from "ngx-infinite-scroll";
import { RadioButtonComponent } from "./components/radio-button/component";

@NgModule({
  declarations: [
    ValidationMessageComponent,
    HeaderComponent,
    SideBarComponent,
    BreadcrumbComponent,
    TransactionStatusPipe,
    CommonNumberDirective,
    ImageCropperComponent,
    RepeatTimesPipe,
    ButtonComponent,
    CurrencyAmountComponent,
    AbsPipe,
    ConfirmBoxComponent,
    CardImageDirective,
    CommaSeparatDirective,
    DateFormatPipe,
    PaginationComponent,
    SpaceRemovalPipe,
    CardNumberDirective,
    TabComponent,
    TwoSideRowComponent,
    InfoBoxComponent,
    PureInputComponent,
    FormControlInputComponent,
    ToggleSwitchComponent,
    ImageUploadComponent,
    SelectableChipControlComponent,
    RadioButtonGroupComponent,
    PageBoxWithBackComponent,
    GeneralTableComponent,
    TypeaheadInputComponent,
    MultiSelectCheckboxComponent,
    MultiSelectDropdownComponent,
    BaseInfiniteScrollComponent,
    RadioButtonComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ImageCropperModule,
    NgxShimmerLoadingModule,
    BsDatepickerModule.forRoot(),
    DatepickerModule.forRoot(),
    FormsModule,
    ReactiveFormsModule,
    NgxUiLoaderModule,
    TabsModule,
    TranslateModule,
    PaginationModule,
    TypeaheadModule.forRoot(),
    AngularMultiSelectModule,
    PopoverModule.forRoot(),
    InfiniteScrollModule,
  ],
  exports: [
    ButtonComponent,
    ValidationMessageComponent,
    HeaderComponent,
    SideBarComponent,
    BreadcrumbComponent,
    TransactionStatusPipe,
    RepeatTimesPipe,
    TabComponent,
    CommonNumberDirective,
    NgxShimmerLoadingModule,
    BsDatepickerModule,
    DatepickerModule,
    FormsModule,
    CurrencyAmountComponent,
    ReactiveFormsModule,
    AbsPipe,
    NgxUiLoaderModule,
    TranslateModule,
    CardImageDirective,
    CommaSeparatDirective,
    DateFormatPipe,
    PaginationComponent,
    TwoSideRowComponent,
    SpaceRemovalPipe,
    CardNumberDirective,
    InfoBoxComponent,
    PureInputComponent,
    FormControlInputComponent,
    ToggleSwitchComponent,
    ImageUploadComponent,
    SelectableChipControlComponent,
    RadioButtonGroupComponent,
    PageBoxWithBackComponent,
    GeneralTableComponent,
    TypeaheadInputComponent,
    MultiSelectCheckboxComponent,
    MultiSelectDropdownComponent,
    BaseInfiniteScrollComponent,
    RadioButtonComponent,
  ],
})
export class SharedModule {}
